import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import MotivesActions, { MotivesRedux, MotivesTypes } from '../Redux/MotivesRedux'
import { notificationFail } from '../Redux/NotificationActions'

const motivesCrudObservable = createCRUDObservable({
  mainRedux: MotivesRedux,
  reduxPath: 'motives',
})

const motivesExcelEpic = (action$, store, { Api }) =>
  action$.ofType(MotivesTypes.MotivesExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.motives.getMotivesExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            MotivesActions.MotivesExcelSuccess(),
          ]
        })
    ))

export const motivesObservers = Object.assign({}, motivesCrudObservable.observers, {})

export const motivesEpic = combineEpics(
  motivesCrudObservable.epic,
  motivesExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/MotivesObservable.js